var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 8,
  viewBox: "0 0 13 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.3536 3.64645C12.5488 3.84171 12.5488 4.15829 12.3536 4.35355L9.17157 7.53553C8.97631 7.7308 8.65973 7.7308 8.46447 7.53553C8.2692 7.34027 8.2692 7.02369 8.46447 6.82843L11.2929 4L8.46447 1.17157C8.2692 0.97631 8.2692 0.659728 8.46447 0.464465C8.65973 0.269203 8.97631 0.269203 9.17157 0.464465L12.3536 3.64645ZM-4.37114e-08 3.5L12 3.5L12 4.5L4.37114e-08 4.5L-4.37114e-08 3.5Z",
  fill: "black"
})));
export default SvgArrowIcon;